<template>
    <div class="shop-search">
                        <el-form ref="data" :model="searchForm" label-width="100px">
            <el-row>
           <el-col :lg="8">
               <el-form-item label="品牌:">
               <el-radio-group v-model="searchForm.brandId">
                   <el-radio :label="1" >N牌</el-radio>
                   <el-radio :label="2" >S牌</el-radio>
               </el-radio-group>
                 </el-form-item>
           </el-col>
           <el-col :lg="8">
               <el-form-item label="店櫃名稱:">
                   <el-input v-model="searchForm.shopName"></el-input>
               </el-form-item>
           </el-col>
            </el-row>
            <el-row>
                <el-col :lg="8">
                    <el-form-item label="店櫃代碼:">
                        <el-input v-model="searchForm.shopId"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :offset="2">
                      <el-button type="primary"  @click="fetch"> <i class="el-icon-search"></i> 查詢</el-button>
                </el-col>
            </el-row>
         </el-form>
          <el-row type="flex" justify="end">
             <el-col :lg="6">
                 <el-button type="primary" @click="addShopTabs">增加店櫃</el-button>
             </el-col>
         </el-row>
               <el-row  type="flex" justify="center"  tag="main">
      <el-col :lg="22" >
        <el-table :data="shopList.slice((currentPage-1)*pagesize,currentPage*pagesize)" 
        :header-cell-style="tableHeaderColor"
        empty-text="暫無數據"
        max-width="85%" height="70vh" stripe  >
          <el-table-column prop="name"  label="店櫃名稱" ></el-table-column>
          <el-table-column prop="tel"  label="店櫃電話" ></el-table-column>
        
              <el-table-column label="詳細"> 
                  <template slot-scope="scope">
                      <el-button type="info"  icon="el-icon-more" @click="detailTabs(scope.$index, scope.row)" circle ></el-button>
                  </template>
              </el-table-column>
              <el-table-column label="狀態" prop="status">
                  <template slot-scope="scope">
                      <el-switch v-model="scope.row.status" active-text="開啟" inactive-text="關閉" active-color="#13ce66" inactive-color="#ff4949" @change="updateStatus(scope.$index, scope.row)"></el-switch>
                  </template>
              </el-table-column>
        </el-table>
         
          <el-pagination
        background
        layout="prev, pager, next"
        :total="total1"
        @current-change="current_change"
        >
      </el-pagination>
        
      </el-col>
        </el-row>
      
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
    export default {
        name: 'Search',
        data() {
            return {
                searchForm: {
                    brandId: 1,
                    shopName: '',
                    shopId: ''
                },
                shopList: [],
                  total1: 0,
                 currentPage:1,
                pagesize: 10,
                shopKey: ''
            }
        },
        computed: 
            mapGetters(["getShopList"]),
        methods: {
            ...mapActions(["fetchShop", "updateShopStatus"]),
              current_change: function (currentPage) {
                this.currentPage = currentPage;
            },
            fetch(){
                const data = {
                    brand_id: this.searchForm.brandId,
                    name: this.searchForm.shopName,
                    shop_id: this.searchForm.shopId
                }
                this.$store.dispatch('fetchShop', data)
                .then(() => {
                    this.shopList = this.getShopList
                    this.total1 = this.shopList.length
                }).catch((err) => {
                    console.log(err)
                });
            },
            updateStatus(indrx, row){
                const data = {
                    _key: row._key,
                    status: row.status
                }
                this.$store.dispatch('updateShopStatus', data)
               .then(() => {
                         this.$notify({
                       title: '成功',
                       message: '改變店櫃狀態成功',
                       type: 'success'
                   })
               }).catch((err) => {
                   this.$notify({
                       title: '失敗',
                       message: '改變店櫃狀態失敗'
                   })
               });
            },
              tableHeaderColor({row, column, rowIndex, columnIndex}){
                if(rowIndex === 0){
                    return `background-color: gray;color: #000;`
                }
            },
            
            addShopTabs(){
                this.$emit('addTabs')
            },
            detailTabs(index, row){
                this.shopKey = row._key
                this.$emit('detailTabs', this.shopKey)
            }
        },
    }
</script>

<style lang="scss"  scoped>
    body {
        margin: 0 auto;
        padding: 0;
            font-weight: bold;
         font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
    }
    .shop-search {
            font-weight: bold;
         font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
    }

    a {
            font-weight: bold;
         font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
    }
</style>